export default {
  methods: {
    handleMonthString(dateFormat) {
      const dateMonthDigit = dateFormat?.mm?.match(/[a-z][0-9]/g)?.join();
      const dateMonthString = dateFormat?.M?.match(/[a-z][0-9]/g)?.join();
      const formatType = dateMonthDigit ? 'mm' : 'M';
      const date = dateFormat;

      if (!date.dd) {
        date.dd = '01';
      }

      if (dateMonthDigit || dateMonthString) {
        const tempDate = dateFormat[formatType];
        date.M = tempDate.match(/([A-Za-zä])+/g).join();
        date.yyyy = tempDate.match(/[0-9]+/g, '').join();
      }

      if (date.M) {
        const months = [
          ...Date.shortMonths.map((x, i) => ({ month: x.toLowerCase(), id: i + 1 })),
          ...Date.longMonths.map((x, i) => ({ month: x.toLowerCase(), id: i + 1 })),
        ];
        date.mm = months.find((x) => x.month === date.M.toLowerCase())?.id;
      }

      return date;
    },
    normalizeDate(date, format) {
      let tempDate = date;
      if (date instanceof Date) {
        tempDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      }

      // Add check to ensure tempDate is a string before calling split
      if (!tempDate || typeof tempDate !== 'string') {
        this.emitUpdate('');
        return '';
      }

      const dateString = _.compact(tempDate.split(/[.|,| |/|-]/g));
      const formatString = _.compact(format.split(/[.|,| |/|-]/g));

      let dateFormat = {};
      formatString.forEach((x, i) => dateFormat[x] = dateString[i]);

      dateFormat = this.handleMonthString(dateFormat);

      if (typeof dateFormat.yyyy === 'undefined' || typeof dateFormat.mm === 'undefined' || typeof dateFormat.dd === 'undefined') {
        this.emitUpdate('');
        return '';
      }

      let year = dateFormat.yyyy;
      const month = dateFormat.mm.toString().padStart(2, 0);
      const day = dateFormat.dd.toString().padStart(2, 0);

      if (dateFormat.yyyy.toString().length === 4) {
        year = dateFormat.yyyy.toString().padStart(3, 0);
      } else {
        year = `${new Date().getFullYear().toString().charAt()}${dateFormat.yyyy.toString().padStart(3, 0)}`;
      }

      return `${year}-${month}-${day}`;
    },
  },
};
